export default __webpack_public_path__ + "static/media/plain-sticker-el.df18ad4c.png";